import { ShiftBottomSheetBookabilityCriteriaCard } from "./BookabilityCriteriaCard";

export function ShiftBottomSheetBookingRequestOverworkCard() {
  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      title="Cannot request shift"
      description="Requesting this shift would cause you to exceed the maximum hours you may book or request back-to-back, per our Terms of Service."
      illustrationType="hours-limit"
    />
  );
}
